import { isEmpty } from 'lodash';
import {
  IAmendmentBankerDetails,
  IAmendmentCostCharges,
  IAmendmentCover,
  IAmendmentExpatDetails,
  IAmendmentMarineDetails,
  IAmendmentMarineHullDetails,
  IAmendmentMedicalDetails,
  IAmendmentMotorDetails,
  IAmendmentRiskDetails,
  IPropertyCoverDetails,
} from '..';
import { isValidNumber } from '@utils/validationUtils';
import { IAmendmentGeneralData } from '../line-amendment';

export const validateCoverRepeaterField = (
  fieldName: keyof IAmendmentCover,
  value: unknown,
  cover: IAmendmentCover
): string => {
  if (fieldName === 'policyCover') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'coverPremiumType') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'coverPremiumPercentage') {
    if (cover.coverPremiumType === 'PERCENTAGE') {
      if (isEmpty(value)) {
        return 'Required';
      } else {
        if (!isValidNumber(value)) {
          return 'Invalid Number';
        }

        const numberValue = Number(value);

        //update
        // if (numberValue < 0 || numberValue > 100) {
        if (numberValue > 100) {
          return 'Value should be between 0 and 100';
        }
      }
    }
  }

  if (fieldName === 'amendmentCoverPremiumPercentage') {
    if (cover.coverPremiumType === 'PERCENTAGE') {
      if (!isEmpty(value)) {
        if (!isValidNumber(value)) {
          return 'Invalid Number';
        }

        const numberValue = Number(value);

        if (numberValue < 0 || numberValue > 100) {
          return 'Value should be between 0 and 100';
        }
      }
    }
  }

  if (fieldName === 'coverPremiumValue') {
    if (cover.coverPremiumType === 'VALUE') {
      if (isEmpty(value)) {
        return 'Required';
      } else {
        if (!isValidNumber(value)) {
          return 'Invalid Number';
        }

        const numberValue = Number(value);

        if (numberValue < 0) {
          return 'Value should be greater than 0';
        }
      }
    }
  }

  if (fieldName === 'amendmentCoverPremiumValue') {
    if (cover.coverPremiumType === 'VALUE') {
      if (!isEmpty(value)) {
        if (!isValidNumber(value)) {
          return 'Invalid Number';
        }
      }
    }
  }

  if (fieldName === 'coverSumInsured') {
    if (isEmpty(value)) {
      return 'Required';
    }

    if (!isValidNumber(value)) {
      return 'Invalid Number';
    }

    const numberValue = Number(value);

    if (numberValue < 0) {
      return 'Value should be greater than 0';
    }
  }

  if (fieldName === 'excessOnClaimType') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'excessOnClaimPercentage') {
    if (cover.excessOnClaimType === 'PERCENTAGE') {
      if (isEmpty(value)) {
        return 'Required';
      } else {
        if (!isValidNumber(value)) {
          return 'Invalid Number';
        }

        const numberValue = Number(value);

        if (numberValue < 0 || numberValue > 100) {
          return 'Value should be between 0 and 100';
        }
      }
    }
  }

  if (fieldName === 'amendmentExcessOnClaimPercentage') {
    if (cover.excessOnClaimType === 'PERCENTAGE') {
      if (!isEmpty(value)) {
        if (!isValidNumber(value)) {
          return 'Invalid Number';
        }

        const numberValue = Number(value);

        if (numberValue < 0 || numberValue > 100) {
          return 'Value should be between 0 and 100';
        }
      }
    }
  }

  if (fieldName === 'excessOnClaimAmount') {
    if (cover.excessOnClaimType === 'VALUE') {
      if (isEmpty(value)) {
        return 'Required';
      } else {
        if (!isValidNumber(value)) {
          return 'Invalid Number';
        }

        const numberValue = Number(value);

        if (numberValue < 0) {
          return 'Value should be greater than 0';
        }
      }
    }
  }

  if (fieldName === 'amendmentExcessOnClaimAmount') {
    if (cover.excessOnClaimType === 'VALUE') {
      if (!isEmpty(value)) {
        if (!isValidNumber(value)) {
          return 'Invalid Number';
        }
      }
    }
  }

  if (fieldName === 'excessOnClaimDays') {
    if (cover.excessOnClaimType === 'DAYS') {
      if (isEmpty(value)) {
        return 'Required';
      } else {
        if (!isValidNumber(value)) {
          return 'Invalid Number';
        }

        const numberValue = Number(value);

        if (numberValue < 0) {
          return 'Value should be greater than 0';
        }
      }
    }
  }

  if (fieldName === 'amendmentExcessOnClaimDays') {
    if (cover.excessOnClaimType === 'DAYS') {
      if (!isEmpty(value)) {
        if (!isValidNumber(value)) {
          return 'Invalid Number';
        }

        const numberValue = Number(value);

        if (numberValue < 0) {
          return 'Value should be greater than 0';
        }
      }
    }
  }

  return '';
};

export const validateCostWidgetField = (
  fieldName: keyof IAmendmentCostCharges,
  value: unknown,
  cover: IAmendmentCostCharges,
  lineExternalCode?: string
): string => {
  if (fieldName === 'amendmentCost') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'tpaFeesType' && lineExternalCode !== '43') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'chargesPercentage') {
    if (isEmpty(value)) {
      return 'Required';
    } else {
      if (!isValidNumber(value)) {
        return 'Invalid Number';
      }

      const numberValue = Number(value);

      if (numberValue < 0 || numberValue > 100) {
        return 'Value should be between 0 and 100';
      }
    }
  }

  if (fieldName === 'tpaFeesPercentage') {
    if (cover.tpaFeesType === 'PERCENTAGE') {
      if (isEmpty(value)) {
        return 'Required';
      } else {
        if (!isValidNumber(value)) {
          return 'Invalid Number';
        }

        const numberValue = Number(value);

        if (numberValue < 0 || numberValue > 100) {
          return 'Value should be between 0 and 100';
        }
      }
    }
  }

  if (fieldName === 'tpaFeesAmount') {
    if (cover.tpaFeesType === 'AMOUNT') {
      if (isEmpty(value)) {
        return 'Required';
      } else {
        if (!isValidNumber(value)) {
          return 'Invalid Number';
        }
      }
    }
  }

  return '';
};

export const validateMotorDetailsField = (
  fieldName: keyof IAmendmentMotorDetails,
  value: any,
  motorDetails: IAmendmentMotorDetails,
  generalData: IAmendmentGeneralData
): string => {
  if (fieldName === 'nameOnLicenseEn' || fieldName === 'nameOnLicenseAr') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (
    generalData.line.externalCode === '50' &&
    (fieldName === 'vignetteCode' || fieldName === 'vignette')
  ) {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'engine') {
    if (isEmpty(value)) {
      return 'Required';
    } else if (!isValidNumber(value) || value.length < 2 || value.length > 50) {
      return 'Invalid Engine';
    }
  }

  if (fieldName === 'plateNumber') {
    if (value && (value.length < 2 || value.length > 300)) {
      return 'Invalid Plate Number';
    }
  }

  if (fieldName === 'yearOfMake') {
    if (isEmpty(value)) {
      return 'Required';
    } else if (Number(value) < 1900 || Number(value) > 2100) {
      return 'Invalid Year of Make';
    }
  }

  if (fieldName === 'weight') {
    if (
      ['VAN', 'PICKUP', 'TANKER', 'F_TANKER'].includes(motorDetails.bodyType)
    ) {
      if (isEmpty(value)) {
        return 'Required';
      } else if (
        !isValidNumber(value) ||
        value.length < 1 ||
        value.length > 2
      ) {
        return 'Invalid Weight';
      }
    }
  }

  if (fieldName === 'engineSize') {
    if (['MOTORCYCLE'].includes(motorDetails.bodyType)) {
      if (isEmpty(value)) {
        return 'Required';
      } else if (
        !isValidNumber(value) ||
        value.length < 1 ||
        value.length > 5
      ) {
        return 'Invalid Engine Size';
      }
    }
  }

  if (fieldName === 'seats') {
    if (isEmpty(value)) {
      return 'Required';
    } else if (!isValidNumber(value) || value.length < 1 || value.length > 2) {
      return 'Invalid Seats';
    }
  }

  if (fieldName === 'chassis') {
    if (isEmpty(value)) {
      return 'Required';
    } else if (value.length < 2 || value.length > 50) {
      return 'Invalid Chassis';
    }
  }

  if (fieldName === 'agencyRepairYear') {
    if (isEmpty(value)) {
      return 'Required';
    } else if (!isValidNumber(value) || value < 0 || value > 10) {
      return 'Value must be between 0 and 10 ';
    }
  }
  if (fieldName === 'depreciationYears') {
    if (isEmpty(value)) {
      return 'Required';
    } else if (!isValidNumber(value) || value < 0 || value > 10) {
      return 'Value must be between 0 and 10 ';
    }
  }

  if (
    fieldName === 'usageType' ||
    fieldName === 'bodyType' ||
    fieldName === 'brand' ||
    fieldName === 'model' ||
    fieldName === 'chassis' ||
    fieldName === 'engineType'
  ) {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (
    fieldName === 'yearOfMake' ||
    fieldName === 'seats' ||
    fieldName === 'horsePower' ||
    fieldName === 'carValue' ||
    fieldName === 'agencyRepairYear'
  ) {
    if (isEmpty(value)) {
      return 'Required';
    } else if (!isValidNumber(value)) {
      return 'Invalid Number';
    } else {
      const numberValue = Number(value);
      if (numberValue < 0) {
        return 'Value should be greater than 0';
      }
    }
  }

  return '';
};

export const validateExpatDetailsField = (
  fieldName: keyof IAmendmentExpatDetails,
  value: unknown
): string => {
  if (fieldName === 'medicalClass') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }
  return '';
};

export const validateMedicalDetailsField = (
  fieldName: keyof IAmendmentMedicalDetails,
  value: any,
  externalCode: string
): string => {
  if (externalCode === '19') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'policyCover') {
    if ((value || []).length === 0) {
      return 'Required';
    }
  }

  return '';
};

export const validateBankerRepeaterField = (
  fieldName: keyof IAmendmentBankerDetails,
  value: IAmendmentBankerDetails[keyof IAmendmentBankerDetails]
): string => {
  if (fieldName === 'branchName') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'isMain') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'isAgency') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'numberOfEmployees') {
    if (isEmpty(value)) {
      return 'Required';
    }

    if (!isValidNumber(value)) {
      return 'Invalid Number';
    }

    const numberValue = Number(value);

    if (numberValue < 0) {
      return 'Value should be greater than 0';
    }
  }

  if (fieldName === 'underwritingYear') {
    if (isEmpty(value)) {
      return 'Required';
    }

    if (!isValidNumber(value)) {
      return 'Invalid Number';
    }
  }

  if (fieldName === 'infidelity') {
    if (isEmpty(value)) {
      return 'Required';
    }

    if (!isValidNumber(value)) {
      return 'Invalid Number';
    }

    const numberValue = Number(value);

    if (numberValue < 0) {
      return 'Value should be greater than or equal to 0';
    }
  }

  if (fieldName === 'burglary') {
    if (isEmpty(value)) {
      return 'Required';
    }

    if (!isValidNumber(value)) {
      return 'Invalid Number';
    }

    const numberValue = Number(value);

    if (numberValue < 0) {
      return 'Value should be greater than or equal to 0';
    }
  }

  if (fieldName === 'holdUp') {
    if (isEmpty(value)) {
      return 'Required';
    }

    if (!isValidNumber(value)) {
      return 'Invalid Number';
    }

    const numberValue = Number(value);

    if (numberValue < 0) {
      return 'Value should be greater than or equal to 0';
    }
  }

  if (fieldName === 'inSafe') {
    if (isEmpty(value)) {
      return 'Required';
    }

    if (!isValidNumber(value)) {
      return 'Invalid Number';
    }

    const numberValue = Number(value);

    if (numberValue < 0) {
      return 'Value should be greater than or equal to 0';
    }
  }

  if (fieldName === 'inTransit') {
    if (isEmpty(value)) {
      return 'Required';
    }

    if (!isValidNumber(value)) {
      return 'Invalid Number';
    }

    const numberValue = Number(value);

    if (numberValue < 0) {
      return 'Value should be greater than or equal to 0';
    }
  }

  if (fieldName === 'forgedChecks') {
    if (isEmpty(value)) {
      return 'Required';
    }

    if (!isValidNumber(value)) {
      return 'Invalid Number';
    }

    const numberValue = Number(value);

    if (numberValue < 0) {
      return 'Value should be greater than or equal to 0';
    }
  }

  if (fieldName === 'counterfeitCurrencies') {
    if (isEmpty(value)) {
      return 'Required';
    }

    if (!isValidNumber(value)) {
      return 'Invalid Number';
    }

    const numberValue = Number(value);

    if (numberValue < 0) {
      return 'Value should be greater than or equal to 0';
    }
  }

  if (fieldName === 'clause6') {
    if (isEmpty(value)) {
      return 'Required';
    }

    if (!isValidNumber(value)) {
      return 'Invalid Number';
    }

    const numberValue = Number(value);

    if (numberValue < 0) {
      return 'Value should be greater than or equal to 0';
    }
  }

  if (fieldName === 'falsification') {
    if (isEmpty(value)) {
      return 'Required';
    }

    if (!isValidNumber(value)) {
      return 'Invalid Number';
    }

    const numberValue = Number(value);

    if (numberValue < 0) {
      return 'Value should be greater than or equal to 0';
    }
  }

  return '';
};

export const validateMarineDetailsField = (
  fieldName: keyof IAmendmentMarineDetails,
  value: IAmendmentMarineDetails[keyof IAmendmentMarineDetails]
): string => {
  if (fieldName === 'matter') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'description') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'vesselName') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'from') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'to') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'via') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'survey') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'cargoContract') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'sumPerShipment') {
    if (value && !isValidNumber(value)) {
      return 'Invalid Number';
    }
    const numberValue = Number(value);

    if (numberValue < 0) {
      return 'Value should be greater than 0';
    }
  }

  if (fieldName === 'claimsPayableBy') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'loading') {
    if (isEmpty(value)) {
      return 'Required';
    } else if (!isValidNumber(value)) {
      return 'Invalid Number';
    }
  }

  if (fieldName === 'vesselAge') {
    if (value && !isValidNumber(value)) {
      return 'Invalid Number';
    }
    const numberValue = Number(value);

    if (numberValue < 0) {
      return 'Value should be greater than 0';
    }
  }

  return '';
};

export const validateMarineHullDetailsField = (
  fieldName: keyof IAmendmentMarineHullDetails,
  value: IAmendmentMarineHullDetails[keyof IAmendmentMarineHullDetails]
): string => {
  if (fieldName === 'vesselName') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'connectionPort') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'territorialWaters') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'usage') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'builder') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'constructionYear') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'registeryPort') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'engineType') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'engineHorsePower') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'engineYearBuilt') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  return '';
};

export const validateRiskDetailsField = (
  fieldName: keyof IAmendmentRiskDetails,
  value: IAmendmentRiskDetails[keyof IAmendmentRiskDetails]
): string => {
  if (fieldName === 'riskDescription') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'geoLocation') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  return '';
};

export const validateRiskCoverDetailsField = (
  fieldName: keyof IPropertyCoverDetails,
  value: IPropertyCoverDetails[keyof IPropertyCoverDetails]
): string => {
  if (fieldName === 'planCoverID') {
    if (isEmpty(value)) {
      return 'Required';
    }
  }

  if (fieldName === 'riskRate') {
    if (value && (!isValidNumber(value) || Number(value) < 0)) {
      return 'Invalid Number';
    }
  }

  if (fieldName === 'sumInsured') {
    if (value && (!isValidNumber(value) || Number(value) < 0)) {
      return 'Invalid Number';
    }
  }

  if (fieldName === 'premium') {
    if (value && (!isValidNumber(value) || Number(value) < 0)) {
      return 'Invalid Number';
    }
  }
  return '';
};
